import * as React from 'react';
import {connect} from "react-redux";
import {ITranslatedComponent} from "../../redux/reducers/generalReducer";
import {translate} from 'react-i18next';
import {withRouter, RouteComponentProps} from "react-router";
import {Segment, List, Divider} from 'semantic-ui-react';
import {IApplicationLink} from "../../data/IApplicationLink";
import {History} from 'history';
import {compose} from 'redux';
import {selectUserSettings} from '../../redux/selectors';
import {IUserSettings} from 'src/data/IUserSettings';
import {IReduxState} from 'src/redux/IReduxState';

interface IMapStateToProps {
    userSettings: IUserSettings;
}

interface IRecentDocumentItemProps {
    link: IApplicationLink;
    history: History;
    t: reactI18Next.TranslationFunction;
    index:number;
}

const RecentDocumentItem = (props: IRecentDocumentItemProps) => {
    const handleContextMenu = (event: React.MouseEvent): void => {
        event.preventDefault(); // Prevent the default browser context menu

        const x = event.clientX; // Use viewport-relative X position
        const y = event.clientY; // Use viewport-relative Y position

        // Dispatch the global context menu event
        window.dispatchEvent(
            new CustomEvent('showGlobalContextMenu', {
                detail: { x, y, url: props.link.href },
            })
        );
    };

    return (
        <List.Item
            className={props.index === 0 ? `main-view-recent-item-list first` : `main-view-recent-item-list`}
            as="a"
            onClick={(): void => props.history.push(props.link.href)}
            onContextMenu={handleContextMenu} // Add context menu handler
        >
            <List.Content floated="left" className="item-conten-text">
                {props.link.description.split('/')[0] === 'PSL_LINK' ?
                    props.t(props.link.description.split('/')[0]) + ' / ' +
                    props.t(props.link.description.split('/')[1].split(':')[0]) + ' ' + props.link.description.split('/')[1].split(':')[1] + ' - ' +
                    props.t(props.link.description.split('/')[2].split(':')[0]) + ' ' + props.t(props.link.description.split('/')[2].split(':')[1]) + ' - ' +
                    props.t(props.link.description.split('/')[3].split(':')[0]) + ' ' + props.t(props.link.description.split('/')[3].split(':')[1]
                    .substring(props.link.description.split('/')[3].split(':')[1].indexOf('(') + 1,props.link.description.split('/')[3].split(':')[1].indexOf(')')))
                    : props.t(props.link.description.split('/')[0]) + ' ' + props.link.description.split('/')[1]}
            </List.Content>
            <List.Content floated="right">
                <List.Icon name="arrow right" />
            </List.Content>
        </List.Item>
    );
};

interface IRecentDocumentsProps extends RouteComponentProps<any>, IUserSettings, ITranslatedComponent {
    userSettings: IUserSettings;
}

const RecentDocuments: React.SFC<IRecentDocumentsProps> = ({t, userSettings, history}: IRecentDocumentsProps) => {
    const elements =
        userSettings &&
        userSettings.recentWork &&
        userSettings.recentWork.map((link: IApplicationLink, index: number) => {
            return <RecentDocumentItem key={index} link={link} history={history} t={t} index={index} />;
        });

    return (
        <Segment className="recent-documents-list" >
            <List divided={true} relaxed={true}>
                <List.Item>
                    <List.Header>{t("RECENT_DOCUMENTS")}</List.Header>
                    <Divider />
                </List.Item>
                {elements && elements}
            </List>
        </Segment>
    );
};

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    userSettings: selectUserSettings(state)
});

export default compose(
    withRouter,
    translate("START_VIEW"),
    connect<IMapStateToProps>(mapStateToProps)
)(RecentDocuments);



// WEBPACK FOOTER //
// ./src/views/MainView/RecentDocuments.tsx